<template>
    <div id="create-campaign">
        <div class="app-container" v-show="!$global.loading">

            <div class="page-title mb-3">
                Création d'une Campagne de mise à jour
            </div>

            <v-text-field v-model="campaign.name" background-color="white" label="Nom de votre campagne" outlined>
            </v-text-field>

            <v-stepper @change="setCurrentStep" :value="currentStep" non-linear>
                <v-stepper-header>
                    <v-stepper-step editable step="1">
                        Prestataires ({{ emailsValid.length }})
                    </v-stepper-step>

                    <v-stepper-step editable step="2">
                        Informations
                    </v-stepper-step>

                    <v-stepper-step editable step="3">
                        Contenu de l'e-mail
                    </v-stepper-step>

                    <v-stepper-step editable step="4">
                        Options
                    </v-stepper-step>

                    <v-stepper-step editable step="5">
                        Finaliser
                    </v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                    <v-stepper-content step="1">
                        <verification v-if="providers.length" :is-revival="false">
                        </verification>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                        <information v-if="tabulations.length" :tabulations="tabulations" :select-all="true">
                        </information>
                    </v-stepper-content>

                    <v-stepper-content step="3">
                        <email v-if="providers.length"></email>
                    </v-stepper-content>

                    <v-stepper-content step="4">
                        <options :criterias="criterias" :is-revival="false"
                                 :hasSuggestionOption="hasSuggestionOption">
                        </options>
                    </v-stepper-content>

                    <v-stepper-content step="5">
                        <finalize :cmaj-name="campaign.name" :update-mode="false" :is-revival="false">
                        </finalize>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </div>
    </div>

</template>

<script>
import Verification from "./stepers/Verification"
import Information from "./stepers/Information"
import Email from "./stepers/Email"
import Finalize from "./stepers/Finalize"
import { mapMutations, mapState } from "vuex"
import * as EmailValidator from "email-validator"
import Options from "./stepers/Options.vue"

export default {
    name: "CreateCampaign",
    components: { Options, Finalize, Email, Information, Verification },
    data() {
        return {
            campaign: { name: null },
            contacts: [],
            tabulations: [],
            sender: null,
            receiver: null,
            hasSuggestionOption: false,
            criterias: [],
        }
    },
    methods: {
        ...mapMutations("createCmaj", [
            "setSender", "setFirstPartMail", "setLastPartMail", "setProviders", "setEmailsValid",
            "setEmailsWrong", "setCurrentStep", "resetState", "setTxtIntro", "setTxtIntroAspect", "setTxtIntroCmaj",
        ]),
        getFields() {
            this.$http.get("auth/campaigns/cmaj/referential/fields").then(res => {
                this.tabulations = res.body.data.tabulations
            })
        },
        getProviders() {
            if (Object.keys(this.$route.query).length) {
                this.getProvidersFromUrlQuery()
            } else {
                this.getProvidersFromIds()
            }
        },
        setHasSuggestionOption() {
            let option = undefined
            let exist = false

            this.account.current_contracts.forEach(contract => {
                option = contract.contract_offer.options.find(option => option.code === "MEDIA_SUGGESTION")

                if (option !== undefined) {
                    exist = true
                }
            })

            this.hasSuggestionOption = exist
        },
        getProvidersFromUrlQuery() {
            let query = this.$route.query

            let payload = {
                accountId: this.account.id,
            }

            if (query.category !== undefined) {
                payload.category = query.category
            }

            if (query.has_period !== undefined) {
                payload.has_period = query.has_period
            }

            if (query.copyrights !== undefined) {
                payload.copyrights = query.copyrights
            }

            if (query.photos_quality !== undefined) {
                payload.photos_quality = query.photos_quality
            }

            if (query.last_maj !== undefined) {
                payload.last_maj = query.last_maj
            }

            this.$http.post("auth/providers/query", payload).then(res => {
                this.setProviders(res.body.data.providers)
                this.setEmailLists()
            })
        },
        getProvidersFromIds() {
            let providerIds = localStorage.getItem("providerIds")

            let payload = {
                providerIds: JSON.parse(providerIds),
            }

            this.$http.post("auth/providers/ids", payload).then(res => {
                this.setProviders(res.body.data.providers)
                this.setEmailLists()
            })
        },
        initDefaultName() {
            let year = this.$moment().format("YYYY")

            this.campaign.name = "Campagne de mise à jour " + year
        },
        initFirstPartEmail() {
            let text = "<p>Cher(e) partenaire,</p>" +
              "<p>Nous vous sollicitons pour mettre à jour vos informations diffusées sur notre site internet ainsi que dans nos points d'accueil. " +
              "Au moyen du questionnaire accessible via le bouton ci-dessous, nous vous invitons à mettre à jour vos informations afin de renseigner au mieux nos visiteurs.</p>"

            this.setFirstPartMail(text)
        },
        initLastPartEmail() {
            let text = "<p>Nous restons disponibles pour vous accompagner dans la mise à jour de vos informations.</p>"

            this.setLastPartMail(text)
        },
        setEmailLists() {
            let emailsValid = []
            let emailsWrong = []

            this.providers.forEach(provider => {
                if (provider.contact === null) {
                    provider.error = "Email non renseigné"
                    emailsWrong.push(provider)
                } else if (!EmailValidator.validate(provider.email)) {
                    provider.error = "Mauvais format d'email"
                    emailsWrong.push(provider)
                } else {
                    emailsValid.push(provider)
                }
            })

            this.setEmailsValid(emailsValid)
            this.setEmailsWrong(emailsWrong)
        },
        getInternalCriterias() {
            this.$http.get("auth/account/apidae-criterias").then(res => {
                this.criterias = res.body.data.criterias
            })
        },
        getAccountIntroTxt() {
            let txtIntroAspect = null
            let txtIntro = null

            if (this.account.configurations.txtIntroAspect) {
                txtIntroAspect = this.account.configurations.txtIntroAspect.value
            }

            if (this.account.configurations.txtIntro) {
                txtIntro = this.account.configurations.txtIntro.value
            }

            if (this.aspect !== undefined && this.aspect !== "") {
                this.setTxtIntro(txtIntroAspect)
            } else {
                this.setTxtIntro(txtIntro)
            }

            this.setTxtIntroAspect(txtIntroAspect)
            this.setTxtIntroCmaj(txtIntro)
        },
    },
    async created() {
        this.$global.loading = true

        this.resetState()

        const promise1 = this.$store.dispatch("account/loadSenders").then(() => {
            if (this.senders.length) {
                this.setSender(this.senders[0])
            }
        })

        this.initDefaultName()
        this.initFirstPartEmail()
        this.initLastPartEmail()
        this.setHasSuggestionOption()
        this.getInternalCriterias()
        this.getAccountIntroTxt()

        this.$store.dispatch("account/fetchCategories")
        this.$store.dispatch("account/fetchCommunes")

        const promise2 = this.getFields()
        const promise3 = this.getProviders()

        const promise4 = this.$http.get("auth/account/contacts").then(res => {
            this.contacts = res.body.data.contacts
        })

        Promise.all([promise1, promise2, promise3, promise4]).then(() => {
            setTimeout(() => {
                this.$global.loading = false
            }, 100)
        })

        this.$store.dispatch("account/fetchContacts")
        this.$store.dispatch("resource/fetchCategories")

        this.$global.$on("change-step", (step) => {
            this.currentStep = step
        })
    },
    computed: {
        ...mapState("account", ["senders", "account"]),
        ...mapState("createCmaj", ["emailsValid", "emailsWrong", "providers", "currentStep"]),
    },
    destroyed() {
        this.$global.$off("change-step")
    },
}
</script>
